const CustomInput = () => null;

export default CustomInput;
